{
  "version": 1,
  "asset_id": "f5c99ab1-4714-4f1a-84d1-de8a4c67316e",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/f5c99ab1-4714-4f1a-84d1-de8a4c67316e/exterior-thumb.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/f5c99ab1-4714-4f1a-84d1-de8a4c67316e/exterior-thumb.webp",
  "original_filename": "exterior-thumb.webp",
  "size": 4688,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:30:19Z"
}
